<ion-header class="remove-margin-from-safe-area ion-no-border">
  <ion-toolbar >
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-toolbar>
            <ion-buttons slot="end">
              <ion-button (click)="onCloseModal()" 
                ><ion-icon color="dark" name="close"></ion-icon
              ></ion-button>
            </ion-buttons>
        </ion-toolbar>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col style="text-align: center;">
          <h3 class="subheader-regular">{{('keys.data.permits.permit_information' | translate : {Default:'Permit Information'}) || 'Permit Information'}} </h3>
        </ion-col>
      </ion-row>
    </ion-grid>
    
   
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid >
    <ion-row *ngIf="type=='standard'" >
      <ion-col class="single-col-wider">
        <ion-card class="card-shadow-7">
          <ion-card-header style="text-align: center">
            <ion-card-title
              >{{ permit.LotName }}
             </ion-card-title
            >
          </ion-card-header>
          <ion-card-content>
            <ion-row>
              <ion-col>
              <ion-item lines="none">
                <ion-label slot="start" style="font-weight: bold">{{('keys.data.permits.permit_holder' | translate : {Default:'Permit Holder'}) || 'Permit Holder'}} </ion-label>
                <ion-label slot="end" style="text-align: right">
                  {{permit.firstName}} {{permit.lastName}} 
                </ion-label>
              </ion-item>
            </ion-col>
             
            </ion-row>
            <ion-row>
              <ion-col>
              <ion-item lines="none">
                <ion-label slot="start" style="font-weight: bold">{{('keys.data.permits.sale_window' | translate : {Default:'Sale Window'}) || 'Sale Window'}}</ion-label>
                <ion-label slot="end" style="text-align: right">
                  {{permit.SemTitle}}
                </ion-label>
              </ion-item>
            </ion-col>
             
            </ion-row>
            <ion-row>
              <ion-col>
              <ion-item lines="none">
                <ion-label slot="start" style="font-weight: bold">{{('keys.data.permits.permit_number' | translate : {Default:'Permit Number'}) || 'Permit Number'}}</ion-label>
                <ion-label slot="end" style="text-align: right">
                  {{permit.PermitNo}}
                </ion-label>
              </ion-item>
            </ion-col>
             
            </ion-row>
            <ion-row>
              <ion-col>
              <ion-item lines="none">
                <ion-label slot="start" style="font-weight: bold">{{('keys.data.permits.rental_cost' | translate : {Default:'Rental Cost'}) || 'Rental Cost'}} </ion-label>
                <ion-label slot="end" style="text-align: right">
                  {{ permit.amount | currency }}
                </ion-label>
              </ion-item>
            </ion-col>
             
            </ion-row>
            <ion-row *ngIf="dataService.showRenewals">
              <ion-col>
                <ion-item lines="none">
                  <ion-label slot="start" style="font-weight: bold">{{('keys.data.permit::labels.renewal_status' | translate : {Default:'Permit Renewal Status'}) || 'Permit Renewal Status'}} </ion-label>
                  <ion-toggle slot="end" color="secondary"
                  (ionChange)="getChecked($event,permit.PermitJoinID)"
                 [checked]="toggleChecked"
                ></ion-toggle>
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row *ngIf="dataService.settings?.permits?.enableUserPermitPrinting">
              <ion-col style="text-align: center;">
                <ion-button *ngIf="!permit['lastPrinted']" (click)="downloadPermit(permit['PermitJoinID'])"  color="primary">{{('keys.data.permit.print' | translate : {Default:'Print'}) || 'Print'}}<ion-icon name="print-outline"></ion-icon></ion-button>
                <ion-button   *ngIf="permit['lastPrinted']" disabled   color="primary">{{('keys.data.permits.last_printed' | translate : {Default:'Last Printed'}) || 'Last Printed'}}:{{permit['lastPrinted']}}<ion-icon name="print-outline"></ion-icon></ion-button>
              </ion-col>
            </ion-row>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="type=='temp'" >
      <ion-col class="single-col-wider">
        <ion-card class="card-shadow-7">
          <ion-card-header style="text-align: center">
            <ion-card-title
              >{{ permit.LotName }}
             </ion-card-title
            >
          </ion-card-header>
          <ion-card-content>
            <ion-row>
              <ion-col>
              <ion-item lines="none">
                <ion-label slot="start" style="font-weight: bold">{{('keys.data.permits.permit_holder' | translate : {Default:'Permit Holder'}) || 'Permit Holder'}}</ion-label>
                <ion-label slot="end" style="text-align: right">
                  {{permit.firstName}} {{permit.lastName}} 
                </ion-label>
              </ion-item>
            </ion-col>
             
            </ion-row>
            <ion-row>
              <ion-col>
              <ion-item lines="none">
                <ion-label slot="start" style="font-weight: bold">{{('keys.data.permits.start_date' | translate : {Default:'Start Date'}) || 'Start Date'}} </ion-label>
                <ion-label slot="end" style="text-align: right">
                  {{permit.StartDate | date: dataService.settings['system']['datemask']}} 
                </ion-label>
              </ion-item>
            </ion-col>
             
            </ion-row>
            <ion-row *ngIf="permit.endTime==null">
              <ion-col>
              <ion-item lines="none">
                <ion-label slot="start" style="font-weight: bold">{{('keys.data.permits.end_date' | translate : {Default:'End Date'}) || 'End Date'}}</ion-label>
                <ion-label slot="end" style="text-align: right">
                  {{permit.EndDate | date: dataService.settings['system']['datemask']}} 
                </ion-label>
              </ion-item>
            </ion-col>
             
            </ion-row>
            <ion-row *ngIf="permit.endTime!=null">
              <ion-col style="text-align: center;">
                <div *ngIf="startDistance>0 && expireDistance>0 && startDays<1"> <ion-note >Starts in:</ion-note><ion-chip color="success">{{startHours}}:{{startMinutes}}:{{startSeconds}}</ion-chip>
                </div>
              <ion-item lines="none">
                <ion-label slot="start" style="font-weight: bold">{{('keys.data.permits.temporary_start_time' | translate) || 'Start Time'}}</ion-label>
                <ion-label slot="end" style="text-align: right">
                  {{permit.startTime | date: 'h:mm a'}} 
                </ion-label>
              </ion-item>
              
            </ion-col>
             
            </ion-row>
            <ion-row *ngIf="permit.endTime!=null">
              <ion-col size="12">
              <ion-item lines="none">
                <ion-label slot="start" style="font-weight: bold">{{('keys.data.permits.temporary_end_time' | translate) || 'End Time'}}</ion-label>
                <ion-label slot="end" style="text-align: right">
                  {{permit.endTime | date: 'h:mm a'}} 
                </ion-label>
              </ion-item>
            </ion-col>
             
            </ion-row>
            <ion-row>
              <ion-col>
              <ion-item lines="none">
                <ion-label slot="start" style="font-weight: bold">{{('keys.data.permits.permit_number' | translate : {Default:'Permit Number'}) || 'Permit Number'}}</ion-label>
                <ion-label slot="end" style="text-align: right">
                  {{permit.permitNo}} 
                </ion-label>
              </ion-item>
            </ion-col>
             
            </ion-row>
            <ion-row>
              <ion-col>
              <ion-item lines="none">
                <ion-label slot="start" style="font-weight: bold">{{('keys.data.vehicles.vehicle' | translate : {Default:'Vehicle'}) || 'Vehicle'}}</ion-label>
                <ion-label slot="end" style="text-align: right">
                  {{permit.ColourName}} {{permit.Year}} {{permit.MakeName}} {{permit.Plate}} 
                </ion-label>
                <ion-label *ngIf="permit.VehicleID==guestVehicleID" slot="end" style="text-align: right">
                  {{('keys.data.permits.guest_vehicle' | translate) || 'Guest Vehicle'}}: {{permit.TempPlate}} 
                </ion-label>
              </ion-item>
            </ion-col>
             
            </ion-row>
            <ion-row >
              <ion-col>
              <ion-item lines="none">
                <ion-label slot="start" style="font-weight: bold">{{('keys.data.common.amount' | translate : {Default:'Amount'}) || 'Amount'}}</ion-label>
                <ion-label slot="end" style="text-align: right">
                  {{permit.Amount | currency}} 
                </ion-label>
              </ion-item>
            </ion-col>
             
            </ion-row>
           
            <ion-row *ngIf="expireDistance>0 && startDistance<0 && permit.endTime!=null">
              <ion-col style="text-align: center;">
                
              
                <ion-button sizeSm="12" sizeMd="8" offsetMd="2" sizeLg="6" offsetLg="3" expand="block" color="primary" (click)="openExtendParkingPage(permit.LotNameID)">Extend permit</ion-button>
                <div *ngIf="expireDays<1">
                  <ion-note >Expires in:</ion-note><ion-chip color="danger">{{expireHours}}:{{expireMinutes}}:{{expireSeconds}}</ion-chip>
                 </div>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col style="text-align: center;">
                <ion-button *ngIf="!permit['lastPrinted']" (click)="downloadTempPermit(permit['PermitTempID'])"  color="primary">{{('keys.data.permit.print' | translate : {Default:'Print'}) || 'Print'}}<ion-icon name="print-outline"></ion-icon></ion-button>
                <ion-button *ngIf="permit['lastPrinted']" disabled   color="primary">{{('keys.data.permits.last_printed' | translate : {Default:'Last Printed'}) || 'Last Printed'}}:{{permit['lastPrinted']}}<ion-icon name="print-outline"></ion-icon></ion-button>
              </ion-col>
            </ion-row>
            </ion-card-content>
            </ion-card>
            </ion-col>
            </ion-row>
  </ion-grid>
</ion-content>
